// Package Imports
const { Form } = require("mobx-react-form")
import yup from "mobx-react-form/lib/validators/YUP"
import vjf from "mobx-react-form/lib/validators/VJF"
import * as $pkg from "yup"
import validator from "validator"

// Project Imports
import formObserver from "./formObserver"
import setInitialDefaults from "./initialDefaults"

class AddInsuredProtectionForHealthController extends Form {
  plugins() {
    return {
      vjf: vjf(validator),
      yup: yup({
          package: $pkg,
          schema: (_yup) =>
          _yup.object().shape({
            journey_id: _yup.string().optional(),
            occupation: _yup.object().shape({
                id: _yup.mixed().required("This field is mandatory")
            }),
            education: _yup.object().shape({
              id: _yup.mixed().required("This field is mandatory")
            }),
            location: _yup.array().min(1, "This field is mandatory").required(),
            recommendation: _yup.object().shape({
              id: _yup.mixed().required("This field is mandatory")
            }),
        }),
      })
    }
  }

  setup() {
    return {
      fields: [
        {
          name: "journey_id",
          type: "hidden",
        },
        {
          name: "occupation",
          label: "Occupation",
          placeholder: "",
          value: {},
          extra: {
            optionList: [],
            bottomSheetTitle: "occupation",
          },
        },
        {
          name: "education",
          label: "Education",
          placeholder: "",
          value: {},
          extra: {
            optionList: [],
            bottomSheetTitle: "education",
          },
        },
        {
          name: "location",
          label: "Location",
          placeholder: "Type PIN Code",
          value: [],
          extra: {
            optionList: [],
            bottomSheetTitle: "Select a Location",
          },
        },
        {
          name: "recommendation",
          label: "Recommend Me",
          placeholder: "",
          value: {},
          extra: {
            optionList: [],
            bottomSheetTitle: "Select an Option",
          },
        },
      ],
    }
  }

  setDefaults(journeyData, journeyId) {
    setInitialDefaults(this, journeyData, journeyId)
    // Observer fields
    formObserver(this)
  }
}

export default AddInsuredProtectionForHealthController
